import { useState } from 'react';
import '@/App.css';
import { Menu, X, Heart, Sparkles, GraduationCap, Phone, Mail, MapPin, Clock, Shield, CheckCircle, Users, Calendar, IndianRupee, Star } from 'lucide-react';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    parentName: '',
    email: '',
    phone: '',
    childName: '',
    childAge: '',
    program: '',
    contactMethod: 'WhatsApp',
    message: ''
  });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! We will contact you within 24 hours.');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919257892300?text=Hi, I want to know more about Vatsalya Aangan programs', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919257892300';
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">
            <div className="flex items-center space-x-3">
              <img 
                src="/vatsalya-logo.png" 
                alt="Vatsalya Aangan Logo" 
                className="h-20 w-auto"
              />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-6">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors">
                Home
              </button>
              <button onClick={() => scrollToSection('programs')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors">
                Programs
              </button>
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors">
                About
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-purple-600 font-medium transition-colors">
                Contact
              </button>
              
              {/* Social Media Links */}
              <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-300">
                <a href="https://www.facebook.com/profile.php?id=61586802523066" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 transition-colors" title="Facebook">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
                <a href="https://www.instagram.com/vatsalyaaangan/" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700 transition-colors" title="Instagram">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
                <a href="https://www.youtube.com/@VATSALYAAANGAN" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-700 transition-colors" title="YouTube">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                </a>
                <a href="https://share.google/zbouElehHVLxnqjjs" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-gray-900 transition-colors" title="Google">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
                </a>
              </div>
              
              <button 
                onClick={handleWhatsApp}
                className="bg-green-500 text-white px-5 py-2 rounded-full hover:bg-green-600 transition-colors font-medium"
              >
                WhatsApp Us
              </button>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-gray-700 hover:text-purple-600"
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden pb-4">
              <div className="flex flex-col space-y-3">
                <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-purple-600 font-medium text-left">
                  Home
                </button>
                <button onClick={() => scrollToSection('programs')} className="text-gray-700 hover:text-purple-600 font-medium text-left">
                  Programs
                </button>
                <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-purple-600 font-medium text-left">
                  About
                </button>
                <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-purple-600 font-medium text-left">
                  Contact
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-28 pb-16 min-h-screen flex items-center relative overflow-hidden bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-32 h-32 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
          <div className="absolute top-40 right-10 w-32 h-32 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
          <div className="absolute bottom-20 left-20 w-32 h-32 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center">
            <div className="inline-block bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              🌟 Jaipur's Trusted Daycare Since Feb 2026
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6 leading-tight">
              Nurturing Jaipur's Children in <span className="bg-gradient-to-r from-purple-600 via-pink-500 to-orange-500 bg-clip-text text-transparent">Complete Safety!</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium">
              Day Care Services 8:30AM-6:30PM | From ₹6,500/month | Flexible Refunds
            </p>
            <div className="flex flex-wrap gap-4 mb-8 justify-center">
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center gap-2"
              >
                <Calendar size={20} /> Book Free Trial
              </button>
              <button 
                onClick={() => scrollToSection('programs')}
                className="bg-white text-purple-600 border-2 border-purple-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-purple-50 transition-all duration-300"
              >
                View Programs
              </button>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <CheckCircle className="text-green-500" size={20} />
                <span>24/7 CCTV</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="text-green-500" size={20} />
                <span>Trained Staff</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="text-green-500" size={20} />
                <span>Safe Environment</span>
              </div>
            </div>
          </div>
          
          {/* Centre Images Showcase - Easily replaceable */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="rounded-2xl overflow-hidden shadow-lg transform hover:scale-105 transition-transform">
              <img 
                src="/centre-image-1.jpg" 
                alt="Kids playing with educational toys at Vatsalya Aangan" 
                className="w-full h-48 object-cover"
                data-image-placeholder="centre-image-1"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg transform hover:scale-105 transition-transform">
              <img 
                src="/centre-image-2.jpg" 
                alt="Children enjoying foosball at our daycare" 
                className="w-full h-48 object-cover"
                data-image-placeholder="centre-image-2"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg transform hover:scale-105 transition-transform">
              <img 
                src="/centre-image-3.jpg" 
                alt="Outdoor play activities with trained staff" 
                className="w-full h-48 object-cover"
                data-image-placeholder="centre-image-3"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg transform hover:scale-105 transition-transform">
              <img 
                src="/centre-image-4.jpg" 
                alt="Kids showcasing their creative artwork" 
                className="w-full h-48 object-cover"
                data-image-placeholder="centre-image-4"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Programs & Fees Section */}
      <section id="programs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Programs & <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Fees</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Affordable, flexible childcare plans designed for working Jaipur families
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Full Day Care */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock className="text-white" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Full Day Care</h3>
                <p className="text-gray-600">8:30 AM - 6:30 PM Daily</p>
              </div>
              <div className="space-y-4 mb-6">
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600">Monthly</div>
                  <div className="text-3xl font-bold text-purple-600 flex items-center">
                    <IndianRupee size={24} />6,500
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600 mb-1">Quarterly</div>
                  <div className="text-3xl font-bold text-purple-600 flex items-center">
                    <IndianRupee size={24} />17,500
                  </div>
                  <div className="text-xs text-green-600 font-semibold mt-1">✓ 10% Off</div>
                </div>
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600 mb-1">Yearly</div>
                  <div className="text-3xl font-bold text-purple-600 flex items-center">
                    <IndianRupee size={24} />62,400
                  </div>
                  <div className="text-xs text-green-600 font-semibold mt-1">✓ 20% Off</div>
                </div>
              </div>
              <button 
                onClick={() => scrollToSection('contact')}
                className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all"
              >
                Enroll Now
              </button>
            </div>

            {/* After School Care */}
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <GraduationCap className="text-white" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">After School Care</h3>
                <p className="text-gray-600">with Homework Support</p>
              </div>
              <div className="space-y-4 mb-6">
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600">Monthly</div>
                  <div className="text-3xl font-bold text-blue-600 flex items-center">
                    <IndianRupee size={24} />5,000
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600 mb-1">Quarterly</div>
                  <div className="text-3xl font-bold text-blue-600 flex items-center">
                    <IndianRupee size={24} />13,500
                  </div>
                  <div className="text-xs text-green-600 font-semibold mt-1">✓ 10% Off</div>
                </div>
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600 mb-1">Yearly</div>
                  <div className="text-3xl font-bold text-blue-600 flex items-center">
                    <IndianRupee size={24} />48,000
                  </div>
                  <div className="text-xs text-green-600 font-semibold mt-1">✓ 20% Off</div>
                </div>
              </div>
              <button 
                onClick={() => scrollToSection('contact')}
                className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all"
              >
                Enroll Now
              </button>
            </div>

            {/* Emergency/Pay-per-Day Care */}
            <div className="bg-gradient-to-br from-green-50 to-teal-50 p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-green-600 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="text-white" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Pay-per-Day/Adhoc</h3>
                <p className="text-gray-600">When you need us most</p>
              </div>
              <div className="space-y-4 mb-6">
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600">Weekday</div>
                  <div className="text-3xl font-bold text-green-600 flex items-center">
                    <IndianRupee size={24} />500<span className="text-lg">/day</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl">
                  <div className="text-sm text-gray-600">Sunday/Holiday</div>
                  <div className="text-3xl font-bold text-green-600 flex items-center">
                    <IndianRupee size={24} />1,000<span className="text-lg">/day</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl text-center">
                  <div className="text-sm text-gray-600 mb-1">Perfect for</div>
                  <div className="text-base font-semibold text-gray-700">Emergency & Flexible Needs</div>
                </div>
              </div>
              <button 
                onClick={() => scrollToSection('contact')}
                className="w-full bg-gradient-to-r from-green-600 to-teal-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all"
              >
                Book Emergency
              </button>
            </div>
          </div>

          <div className="text-center bg-gradient-to-r from-purple-100 to-pink-100 p-6 rounded-2xl">
            <p className="text-lg font-semibold text-gray-800">
              <span className="text-purple-600">Admission Fee:</span> ₹1,000/child (one-time) | Secure your child's spot today!
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Our <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive activities and care for your little ones
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: '🎨', title: 'Creative Arts & Crafts', desc: 'Hands-on art activities to spark creativity and imagination' },
              { icon: '📖', title: 'Story Time & Reading', desc: 'Interactive storytelling to build language and literacy skills' },
              { icon: '🏃', title: 'Physical Activities', desc: 'Indoor and outdoor play for healthy physical development' },
              { icon: '🧩', title: 'Educational Games', desc: 'Fun learning activities that develop cognitive skills' },
              { icon: '📝', title: 'Homework Support', desc: 'Guided homework assistance for school-age children' },
              { icon: '📹', title: '24/7 CCTV Monitoring', desc: 'Complete safety with live parent access for monitoring' },
              { icon: '🧑‍🏫', title: 'Trained Caregivers', desc: 'Background-verified, certified childcare professionals' },
            ].map((service, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              About <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Vatsalya Aangan</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Nurturing Little Hearts in Jaipur Since February 2026
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Welcome to <strong>Vatsalya Aangan</strong> - Jaipur's newest premium daycare center dedicated to nurturing young minds in a safe, loving, and stimulating environment. We understand the challenges working parents face, and we're here to provide a home away from home for your little ones.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Our experienced and caring staff members are trained in early childhood education and are passionate about child development. With 24/7 CCTV surveillance, nutritious meals, age-appropriate activities, and a child-centric approach, we ensure every child thrives physically, emotionally, and intellectually.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl text-center">
                <div className="text-4xl mb-3">👩‍🏫</div>
                <h4 className="font-bold text-gray-800 mb-2">Trained Staff</h4>
                <p className="text-sm text-gray-600">Background verified & certified</p>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-2xl text-center">
                <div className="text-4xl mb-3">📹</div>
                <h4 className="font-bold text-gray-800 mb-2">24/7 CCTV</h4>
                <p className="text-sm text-gray-600">Complete safety monitoring</p>
              </div>
              <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-6 rounded-2xl text-center">
                <div className="text-4xl mb-3">💜</div>
                <h4 className="font-bold text-gray-800 mb-2">Loving Care</h4>
                <p className="text-sm text-gray-600">Home away from home</p>
              </div>
              <div className="bg-gradient-to-br from-green-50 to-teal-50 p-6 rounded-2xl text-center">
                <div className="text-4xl mb-3">🎯</div>
                <h4 className="font-bold text-gray-800 mb-2">Structured Learning</h4>
                <p className="text-sm text-gray-600">Age-appropriate activities</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-16">
            <h3 className="text-3xl font-bold text-center text-gray-800 mb-12">
              Why Choose <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Vatsalya Aangan</span>?
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { title: 'Experienced Staff', desc: 'Trained and certified childcare professionals who love working with children' },
                { title: 'Safe Environment', desc: 'Child-proofed facilities with constant supervision and security measures' },
                { title: 'Age-Appropriate Programs', desc: 'Customized activities designed for different age groups and development stages' },
                { title: 'Flexible Timings', desc: 'Convenient schedules to accommodate working parents' },
                { title: 'Holistic Development', desc: 'Focus on physical, emotional, social, and cognitive growth' },
                { title: 'Parent Communication', desc: 'Regular updates and open communication with parents' },
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-4 p-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl">
                  <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold">
                    ✓
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                    <p className="text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Centre Photos Showcase */}
          <div className="mt-12">
            <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Our <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Happy Place</span>
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="rounded-3xl overflow-hidden shadow-xl">
                <img 
                  src="/centre-image-1.jpg" 
                  alt="Indoor play area with educational toys" 
                  className="w-full h-72 object-cover"
                  data-image-placeholder="about-image-1"
                />
              </div>
              <div className="rounded-3xl overflow-hidden shadow-xl">
                <img 
                  src="/centre-image-3.jpg" 
                  alt="Outdoor activities with caring staff" 
                  className="w-full h-72 object-cover"
                  data-image-placeholder="about-image-2"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              What <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Parents Say</span>
            </h2>
            <p className="text-xl text-gray-600">Trusted by families across Jaipur</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { name: 'Priya Sharma', role: 'Working Mom', text: 'Perfect for working moms! The staff is caring and my daughter loves going here every day.' },
              { name: 'Rajesh Kumar', role: 'Parent', text: 'Best daycare in Jaipur! The flexible refund policy and homework support is excellent.' },
              { name: 'Anita Verma', role: 'Mother of Two', text: 'Safe, clean, and my kids have learned so much. Highly recommend Vatsalya Aangan!' },
              { name: 'Vikram Singh', role: 'Father', text: 'Great value for money. The emergency care option is a lifesaver for our family.' },
            ].map((testimonial, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-700 mb-4 italic">"{testimonial.text}"</p>
                <div>
                  <p className="font-bold text-gray-800">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section - After Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Glimpses of <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Our Centre</span>
            </h2>
            <p className="text-xl text-gray-600">See where your child will learn, play, and grow</p>
          </div>

          {/* Horizontal Scrollable Gallery */}
          <div className="relative">
            <div 
              id="gallery-scroll-container"
              className="flex gap-6 overflow-x-auto scroll-smooth pb-8 snap-x snap-mandatory scrollbar-hide"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              {/* Gallery Image 1 */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-4.jpg" 
                    alt="Children proudly showing their creative artwork" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-1"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Creative Learning</h3>
                    <p className="text-white/90 text-sm">Kids showcase their artistic talents</p>
                  </div>
                </div>
              </div>
              
              {/* Gallery Image 2 */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-2.jpg" 
                    alt="Kids enjoying indoor games and activities" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-2"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Interactive Play</h3>
                    <p className="text-white/90 text-sm">Fun-filled activities that engage</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 3 */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-1.jpg" 
                    alt="Indoor play area with educational toys" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-3"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Play & Learn Zone</h3>
                    <p className="text-white/90 text-sm">Educational toys and games</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 4 */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-3.jpg" 
                    alt="Outdoor play activities with caring staff" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-4"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Outdoor Fun</h3>
                    <p className="text-white/90 text-sm">Physical activities with supervision</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 5 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-1.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-5"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 6 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-2.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-6"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 7 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-3.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-7"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 8 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-4.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-8"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 9 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-1.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-9"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>

              {/* Gallery Image 10 - Placeholder */}
              <div className="flex-shrink-0 w-80 snap-start">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl group h-96">
                  <img 
                    src="/centre-image-2.jpg" 
                    alt="Upload your centre photo here" 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                    data-image-placeholder="gallery-image-10"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                    <h3 className="text-white font-bold text-xl">Your Photo Here</h3>
                    <p className="text-white/90 text-sm">Replace with your centre image</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Scroll Navigation Buttons */}
            <div className="flex justify-center gap-4 mt-6">
              <button 
                onClick={() => {
                  const container = document.getElementById('gallery-scroll-container');
                  container.scrollBy({ left: -320, behavior: 'smooth' });
                }}
                className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-4 rounded-full hover:shadow-lg transition-all"
                aria-label="Scroll left"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button 
                onClick={() => {
                  const container = document.getElementById('gallery-scroll-container');
                  container.scrollBy({ left: 320, behavior: 'smooth' });
                }}
                className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-4 rounded-full hover:shadow-lg transition-all"
                aria-label="Scroll right"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-purple-600 to-pink-600 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Limited Spots Open!</h2>
          <p className="text-xl mb-8">₹1,000 deposit secures your child's place</p>
          <p className="text-lg mb-8">Don't miss out! Join the Vatsalya Aangan family today and give your child the best care in Jaipur.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <button 
              onClick={handleWhatsApp}
              className="bg-green-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-600 transition-all flex items-center gap-2"
            >
              <Phone size={20} /> WhatsApp Enquiry
            </button>
            <button 
              onClick={handleCall}
              className="bg-white text-purple-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all flex items-center gap-2"
            >
              <Phone size={20} /> Call Now
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-purple-600 transition-all"
            >
              Schedule Tour
            </button>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Reserve Your <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Spot Today</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Fill out the form below and our team will contact you within 24 hours
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Visit Us</h3>
                  <p className="text-gray-600">
                    E-10-A, govindpuri E, Mitra Nagar,<br />
                    Ram Nagar, Sodala,<br />
                    Jaipur-302019, Rajasthan
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full flex items-center justify-center">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Call Us</h3>
                  <p className="text-gray-600">
                    +91 92578 92300<br />
                    Available: Mon-Sat, 8:30AM-6:30PM
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-green-600 to-teal-600 rounded-full flex items-center justify-center">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Email Us</h3>
                  <p className="text-gray-600">
                    vatsalyaaangan@gmail.com<br />
                    We'll respond within 24 hours
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-6 rounded-2xl">
                <h4 className="font-bold text-gray-800 mb-3">Operating Hours</h4>
                <div className="space-y-2 text-gray-700">
                  <p>Monday - Saturday: 8:30 AM - 6:30 PM</p>
                  <p>Sunday: Closed (Emergency care available)</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-3xl shadow-xl">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Quick Inquiry Form</h3>
              <form action="https://api.web3forms.com/submit" method="POST" className="space-y-4">
              <input type="hidden" name="access_key" value="daac8a5a-094f-469f-8112-4e17e709c168" />
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Parent's Name *</label>
                  <input 
                    type="text" 
                    name="parentName"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Enter your name"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Email Address *</label>
                  <input 
                    type="email" 
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Enter your email"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Phone Number *</label>
                  <input 
                    type="tel" 
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Enter your phone"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Child's Name *</label>
                  <input 
                    type="text" 
                    name="childName"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Enter child's name"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Child's Age *</label>
                  <select
                    name="childAge"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                  >
                    <option value="">Select age</option>
                    <option value="6m-1y">6 months - 1 year</option>
                    <option value="1-2y">1 - 2 years</option>
                    <option value="2-3y">2 - 3 years</option>
                    <option value="3-4y">3 - 4 years</option>
                    <option value="4-5y">4 - 5 years</option>
                    <option value="5+y">5+ years</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Program Interest *</label>
                  <select
                    name="program"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                  >
                    <option value="">Select a program</option>
                    <option value="full-day">Full Day Care</option>
                    <option value="after-school">After School Care</option>
                    <option value="emergency">Pay-per-Day/Adhoc</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Additional Message</label>
                  <textarea 
                    name="message"
                    rows="3" 
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Any special requirements or questions?"
                  ></textarea>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-4 rounded-xl font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  Submit Inquiry 💌
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-purple-900 via-purple-800 to-pink-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="bg-white p-3 rounded-2xl inline-block mb-4">
                <img 
                  src="/vatsalya-logo.png" 
                  alt="Vatsalya Aangan" 
                  className="h-16 w-auto"
                />
              </div>
              <p className="text-purple-100">
                Nurturing young minds with love, care, and excellence in Jaipur.
              </p>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4">Quick Links</h4>
              <div className="space-y-2">
                <button onClick={() => scrollToSection('home')} className="block text-purple-200 hover:text-white transition-colors">
                  Home
                </button>
                <button onClick={() => scrollToSection('programs')} className="block text-purple-200 hover:text-white transition-colors">
                  Programs & Fees
                </button>
                <button onClick={() => scrollToSection('about')} className="block text-purple-200 hover:text-white transition-colors">
                  About Us
                </button>
                <button onClick={() => scrollToSection('contact')} className="block text-purple-200 hover:text-white transition-colors">
                  Contact
                </button>
              </div>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4">Contact Info</h4>
              <div className="space-y-2 text-purple-200">
                <p>+91 92578 92300</p>
                <p>vatsalyaaangan@gmail.com</p>
                <p>E-10-A, govindpuri E, Sodala</p>
                <p>Jaipur-302019</p>
              </div>
            </div>
          </div>
          <div className="border-t border-purple-700 pt-8 text-center text-purple-200">
            <p>&copy; 2026 Vatsalya Aangan. All rights reserved. Made with 💜 for children</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;